<template>
    <div v-show="errorTip" style="margin-left:30px;">
        <Alert type="warning" show-icon>
        	{{$t('alarms.common.warning')}}
            <template slot="desc">{{$t('alarms.common.wechatTip')}}</template>
        </Alert>
    </div>
</template>
<script>
    export default {
        name: 'WechatWarning',
        data () {
            return {
                errorTip: true,
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/common/WechatWarning.vue